/* =============================================================================
   assets/evs-pop.js

   Transforme un bloc marque dans une description produit en pop-up (dialog).

   Balisage attendu dans la description (donc traduit automatiquement avec
   la fiche, aucune chaine de texte n'est ecrite ici) :

     <div class="evs-pop">
       <p class="evs-pop__btn"><b>Titre du bloc</b></p>
       <div class="evs-pop__body"> ...tableau ou texte... </div>
     </div>

   Rendu : le paragraphe devient un bouton ; le contenu part dans un
   <dialog> ouvert au clic, ferme par la croix, par un clic sur le fond ou
   par la touche Echap.

   Sans JavaScript, ou sur un navigateur sans <dialog> (Safari < 15.4), le
   bloc reste affiche tel quel dans le texte : rien n'est perdu.

   Cree le 22/09/2026 (Claude), a la demande d'Isma : sur la fiche
   PANORAMA SLIM, le comparatif avec le Dometic Heki 2 ne concerne que la
   taille 960 x 655, une des quatre vendues sur la fiche.
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function build(block) {
    if (block.dataset.evsPopReady) return;

    var label = block.querySelector('.evs-pop__btn');
    var body = block.querySelector('.evs-pop__body');
    if (!label || !body) return;

    var title = (label.textContent || '').trim();

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'evs-pop__trigger';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.innerHTML =
      '<span class="evs-pop__trigger-label"></span>' +
      '<svg class="evs-pop__trigger-ico" viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
      'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false"><path d="M15 3h6v6"/><path d="M10 14 21 3"/>' +
      '<path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5"/></svg>';
    trigger.querySelector('.evs-pop__trigger-label').textContent = title;

    var dialog = document.createElement('dialog');
    dialog.className = 'evs-pop__dlg';

    var head = document.createElement('div');
    head.className = 'evs-pop__head';
    var h = document.createElement('p');
    h.className = 'evs-pop__title';
    h.textContent = title;
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'evs-pop__close';
    close.setAttribute('aria-label', title);
    close.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
      'stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12"/><path d="M18 6 6 18"/></svg>';
    head.appendChild(h);
    head.appendChild(close);

    var inner = document.createElement('div');
    inner.className = 'evs-pop__content rte';
    while (body.firstChild) inner.appendChild(body.firstChild);

    dialog.appendChild(head);
    dialog.appendChild(inner);
    document.body.appendChild(dialog);

    label.replaceWith(trigger);
    body.remove();
    block.classList.add('is-ready');
    block.dataset.evsPopReady = '1';

    trigger.addEventListener('click', function () {
      dialog.showModal();
    });
    close.addEventListener('click', function () {
      dialog.close();
    });
    /* Clic sur le fond : la cible est le <dialog> lui-meme, jamais son
       contenu, qui est entierement couvert par .evs-pop__content. */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      trigger.focus();
    });
  }

  ready(function () {
    if (typeof HTMLDialogElement === 'undefined' ||
        typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    document.querySelectorAll('.evs-pop').forEach(build);
  });
})();
